import { Controller } from "@hotwired/stimulus";

// Static page — the accordion itself is plain native <details>/<summary>, no JS
// needed for that. Kept for this project's own convention of every component
// carrying its own controller file.
export default class extends Controller {
  connect() {}
}
